import { render } from "./InactiveUser.vue?vue&type=template&id=01a50ed8&scoped=true&ts=true"
import script from "./InactiveUser.vue?vue&type=script&lang=ts"
export * from "./InactiveUser.vue?vue&type=script&lang=ts"

import "./InactiveUser.vue?vue&type=style&index=0&id=01a50ed8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01a50ed8"]])

export default __exports__